import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { interval, Subscription } from 'rxjs';
import { AudioToText } from '../audio-to-text';

@Component({
  selector: 'app-voice-bars',
  imports: [CommonModule],

  standalone: true,
  templateUrl: './voice-bars.component.html',
  styleUrl: './voice-bars.component.scss'
})
export class VoiceBarsComponent implements OnInit, OnDestroy {
  private sub: Subscription = new Subscription();
  public bars: number[] = [];

  public barCount = 100;
  constructor(public attService: AudioToText) {


  }

  public ngOnInit(): void {
    for (let i = 0; i < this.barCount; i++) {
      this.bars.push(0);
    }
    this.sub = interval(50).subscribe(() => {
      this.addTick();

    });
  }

  public addTick(): void {
    console.log("hi")
    this.bars.push(this.attService.volumeScalePercentage);
    if (this.bars.length > this.barCount) {
      this.bars.shift();
    }
  }

  public ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
